<template>
<main class="contents_main">
  <div class="entry">
    <section id="entry-info">
      <div class="entry-info">
        <h2>{{$t('MEMBER_REQUEST_FORM_TOP_CONTENT1')}}</h2>
        <p>
          {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT2')}}<br />
          {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT3')}}<br />
          {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT8')}}
        </p>
        <ul class="">
          <li>
            {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT4')}}
          </li>
          <li>
            {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT5')}}
          </li>
          <li>
            {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT6')}}
          </li>
        </ul>
        <p>
          {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT9')}}<br />
          {{$t('MEMBER_REQUEST_FORM_TOP_CONTENT10')}}<a
           @click="downloadFile(memberRegisterFormExcel)">Excel</a>/<a @click="downloadFile(memberRegisterFormPdf)">PDF</a
          >{{$t('MEMBER_REQUEST_FORM_TOP_CONTENT11')}}
        </p>
      </div>
    </section>
    <section id="entry-form" class="entry-form">
      <form>
        <p class="entry-form-info" v-html="$t('MEMBER_REQUEST_FORM_TOP_CONTENT7')"></p>
        <table class="tbl-entry">
          <tbody>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_NICKNAME_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="text" class="iptW-M" required v-model="parent.registerData.nickname" v-bind:class="{'err': errors.nickname}" @keydown="errors.nickname=null" ref="nickname">
                <p v-if="errors.nickname" class="err-txt">{{errors.nickname}}</p>
                <p v-if="errors.nickname_dup" class="err-txt">{{errors.nickname_dup}}</p>
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_NAME_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="text" class="iptW-M" required v-model="parent.registerData.name" v-bind:class="{'err': errors.name}" @keydown="errors.name=null" ref="name">
                <p class="err-txt">{{errors.name}}</p>
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_FURIGANA_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="text" class="iptW-M" required v-model="parent.registerData.furigana" v-bind:class="{'err': errors.furigana}" @keydown="errors.furigana=null" ref="furigana">
                <p class="err-txt">{{errors.furigana}}</p>
              </td>
            </tr>
            <tr class="account-wrap">
              <th>
                {{$t('MEMBER_REQUEST_FORM_TYPE_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td class="form-select">
                <select required v-model="parent.registerData.type" v-bind:class="{'err': errors.type}" ref="type">
                  <option
                    v-for="constant in parent.constants.filter(constant => constant.key_string == 'MEMBER_TYPE')"
                    :value="constant.value1"
                    :label="constant.value2"
                    selected="selected"
                    :key="constant.value1">{{constant.value2}}</option>
                </select>
                <!-- <p class="err-txt">{{errors.type}}</p> -->
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_OWNER_ASSOCIATION_LABEL')}}
              </th>
              <td>
                <input type="text" class="iptW-M" required v-model="parent.registerData.ownerAssociation" v-bind:class="{'err': errors.ownerAssociation}" @keydown="errors.ownerAssociation=null" ref="ownerAssociation">
                <p class="err-txt">{{errors.ownerAssociation}}</p>
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_REPRESENTATIVE_LABEL')}}
                <span class="d-inline-block u-em8">{{$t('MEMBER_REQUEST_REPRESENTATIVE_LABEL2')}}</span>
              </th>
              <td>
                <input type="text" class="iptW-M" required v-model="parent.registerData.representative" v-bind:class="{'err': errors.representative}" @keydown="errors.representative=null" ref="representative">
                <p class="err-txt">{{errors.representative}}</p>
              </td>
            </tr>
            <tr class="account-wrap">
              <th>
                {{$t('MEMBER_REQUEST_FORM_POST_CODE_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <div class="ipt-wrap">
                  <input
                    type="text"
                    class="ime-dis iptW-S"
                    v-model="parent.registerData.postCode"
                    @keydown="errors.postCode=null"
                    required v-bind:class="{'err': errors.postCode}"
                    ref="postCode" />
                  <input class="ipt-btn-gray zip-search" type="button" :value="$t('MEMBER_REQUEST_FORM_SEARCH_POST_CODE_BUTTON_LABEL')" @click="searchPostCode">
                  <p class="err-txt">{{errors.postCode}}</p>
                </div>
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_EDIT_FORM_ADDRESS_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="text" class="iptW-M" :placeholder="$t('MEMBER_REQUEST_FORM_LOCATION_PLACEHOLDER')" required v-model="parent.registerData.address" v-bind:class="{'err': errors.address}" @keydown="errors.address=null" ref="address">
                <p class="err-txt">{{errors.address}}</p>
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_FORM_TEL_LABEL')}}<br />
                <span class="u-em8">{{$t('MEMBER_REQUEST_FORM_TEL_LABEL2')}}</span>
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="text" class="ime-dis iptW-M" :placeholder="$t('MEMBER_REQUEST_FORM_PHONE_NUMBER_PLACEHOLDER')" required v-model="parent.registerData.tel" v-bind:class="{'err': errors.tel}" @keydown="errors.tel=null" ref="tel">
                <p class="err-txt">{{errors.tel}}</p>
              </td>
            </tr>
            <tr>
              <th>{{$t('MEMBER_REQUEST_FORM_FAX_LABEL')}}</th>
              <td>
                <input type="text" class="ime-dis iptW-M" :placeholder="$t('MEMBER_REQUEST_FORM_FAX_NUMBER_PLACEHOLDER')" v-model="parent.registerData.fax" v-bind:class="{'err': errors.fax}" @keydown="errors.fax=null" ref="fax">
                <p class="err-txt">{{errors.fax}}</p>
              </td>
            </tr>

            <tr class="account-wrap">
              <th>
                {{$t('MEMBER_REQUEST_FORM_EMAIL_LABEL')}}<br />
                <span class="u-em8">{{$t('MEMBER_REQUEST_FORM_EMAIL_LABEL2')}}</span>
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="email" class="ime-dis iptW-M" required v-model="parent.registerData.email" v-bind:class="{'err': errors.email}" @keydown="errors.email=null" ref="email">
                <p v-if="errors.email" class="err-txt">{{errors.email}}</p>
                <p v-if="errors.email_dup" class="err-txt">{{errors.email_dup}}</p>
              </td>
            </tr>
            <tr class="account-wrap">
              <th>
                {{$t('MEMBER_REQUEST_FORM_CONFIRM_EMAIL_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input type="email" class="ime-dis iptW-M" required v-model="parent.confirmEmail" v-bind:class="{'err': errors.confirmEmail}" @keydown="errors.confirmEmail=null" ref="confirmEmail">
                <p v-if="errors.confirmEmail" class="err-txt">{{errors.confirmEmail}}</p>
              </td>
            </tr>

            <tr>
              <th>
                {{$t('MEMBER_REQUEST_CONFIRM_PASSWORD_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input :type="passwordType" class="ime-dis iptW-M password" required v-model="parent.registerData.password" v-bind:class="{'err': errors.password}" @keydown="errors.password=null" ref="password" autocomplete="new-password">
                <span @click="showHidePassword(2)" class="show-password"><Icon :icon="passwordType === 'password' ? 'akar-icons:eye' : 'akar-icons:eye-slashed'" style="vertical-align: middle;"/></span>
                <p class="err-txt">{{errors.password}}</p>
              </td>
            </tr>
            <tr v-if="!errors.password">
              <th>
                &nbsp;
              </th>
              <td class="u-em8 u-pt0">
                {{$t('MEMBER_REQUEST_FORM_PASSWORD_RULE')}}
              </td>
            </tr>
            <tr>
              <th>
                {{$t('MEMBER_REQUEST_CONFIRM_CONFIRM_PASSWORD_LABEL')}}
                <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
              </th>
              <td>
                <input :type="passwordConfirmType" class="ime-dis iptW-M password" required v-model="parent.confirmPassword" v-bind:class="{'err': errors.confirmPassword}" @keydown="errors.confirmPassword=null" ref="confirmPassword" autocomplete="new-password">
                <span @click="showHidePassword(3)" class="show-password"><Icon :icon="passwordConfirmType === 'password' ? 'akar-icons:eye' : 'akar-icons:eye-slashed'" style="vertical-align: middle;"/></span>
                <p class="err-txt">{{errors.confirmPassword}}</p>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="form-privacy">
          {{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE1')}}
          <a @click="$routerGoNewWindow($define.PAGE_NAMES.PRIVACY_PAGE_NAME, null, {lang: $i18n.locale})">{{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE2')}}</a>
          {{$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_CAUTION_MESSAGE3')}}
        </p>
        <table class="tbl-entry tbl-privacy">
          <tr>
            <th>
              {{$t('MEMBER_REQUEST_CONFIRM_AGREE_LABEL') + $t('MEMBER_REQUEST_CONFIRM_AGREE_LABEL2')}}
              <em class="req">{{$t('MEMBER_REQUEST_FORM_REQUIRED_LABEL')}}</em>
            </th>
            <td class="privacy-chk">
              <label for="rule-chk">
                <input type="checkbox" id="rule-chk" class="checkbox-input" @click="ruleCheckClick" required>
                <span class="checkbox-parts" v-html="$t('MEMBER_REQUEST_FORM_AGREE_CHECKBOX_LABEL')"></span>
              </label>
            </td>
          </tr>
        </table>
        <div class="btn-form">
          <input type="button" :value="$t('MEMBER_REQUEST_FORM_SUBMIT_LABEL')" :disabled="!ruleCheckBtnClicked" @click="validate">
        </div>
      </form>
    </section>
  </div>
</main>
</template>

<script>
import Methods from '@/api/methods'
import DownloadFile from '@/common/downloadFile'
import {Icon} from '@iconify/vue2'
import RegisterLogic from './RegisterLogic.js'
export default {
  components : {
    Icon
  },
  props : {
    parent : {
      type    : Object,
      default : Object
    }
  },
  data() {
    return {
      scripts : [
        /*
         * 'remodal.min.js',
         * 'login.js'
         */
      ]
    }
  },
  mixins  : [RegisterLogic, DownloadFile],
  methods : {
    request(params) {
      return Methods.apiExcute('request-member', this.$i18n.locale, params)
    },
    extraValidate() {
      if (!this.parent.confirmPassword) {
        this.errors.confirmPassword = this.$t('MEMBER_INFO_EMPTY_MESSAGE')
      } else if (this.parent.registerData.password && this.parent.registerData.password !== this.parent.confirmPassword) {
        this.errors.confirmPassword = this.$t('PASSWORD_CONFIRM_ERROR_MESSAGE')
      }

      if (!this.parent.confirmEmail) {
        this.errors.confirmEmail = this.$t('MEMBER_INFO_EMPTY_MESSAGE')
      } else if (this.parent.registerData.email && this.parent.registerData.email !== this.parent.confirmEmail) {
        this.errors.confirmEmail = this.$t('MAIL_CONFIRM_ERROR_MESSAGE')
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /* 郵便番号検索ボタン */
  .contents_main #entry-form table.tbl-entry td input.zip-search {
    margin: 0 0 0 15px;
    border-radius: 0;
    -webkit-appearance: none;
    background-color: #3C85C6;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    max-width: 100px;
    -webkit-transition: all .08s linear;
    transition: all .08s linear;
  }
  p.err-txt {
    color: #f00;
  }
  select.err {
    background-color: #fffafa !important;
    border: solid 1px #f00 !important;
  }
  label.err {
    background-color: #fffafa !important;
    border: solid 1px #f00 !important;
  }
  @media only screen and (min-width: 768px) {
    #main #entry-form table.tbl-entry th {
      width: 246px !important;
    }
  }
</style>

<style scoped lang="css">
  .v-application p {
    margin-bottom: initial !important;
  }
  .transfer-btn[disabled], .transfer-btn[disabled]:hover {
    background-color: #ccc;
    color: #3C85C6;
    cursor: not-allowed !important;
  }
  .entry-info p a {
      cursor: pointer !important;
      text-decoration: none !important;
  }
</style>
<style scoped src="@/assets/css/contents02.css"></style>
